/* eslint-disable react/no-unknown-property */
import { useEffect, useRef, useState } from "react";
import { BASE_DEV_URL, BASE_URL, IS_B2C } from "../../config/api.config";
import { useSelector } from "react-redux";
import { USER_DATA } from "../../config/app.config";
import { toastr } from "react-redux-toastr";

const PopupImage = ({ setOpen, auth, imgData }) => {
  const popupRef = useRef(null);

  const promotions = useSelector((state) => state.promotions.socials);
  let userData = {};

  try {
    userData = JSON.parse(localStorage.getItem(USER_DATA) || "{}");
  } catch {
    userData = {};
  }

  let { user_name, is_demo } = userData;

  // ⭐ CLOSE WHEN CLICK OUTSIDE
  const handleClickOutside = (e) => {
    if (popupRef.current && !popupRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const affiliateLink = `${BASE_URL}?af_code=${user_name}`;

  const copyAffiliateLink = () => {
    navigator.clipboard
      .writeText(affiliateLink)
      .then(() => {
        toastr.success("", "Link copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <div id="modal-root">
      <div
        className="fixed bottom-0 left-0 right-0 top-0 flex overflow-hidden z-[10000] h-[100dvh] w-dvw items-center justify-center bg-bg_color_popUpParentBg"
        id="PopUpMainContainer"
      >
        <div className="fixed inset-0 w-full h-full bg-black/10 backdrop-blur-sm" />
        <div
          ref={popupRef}
          className="relative p-0 xs:p-0 max-w-[90%] w-max sm:max-w-[85%] md:max-w-[70%] lg:max-w-[800px] max-w-[800px] relative bg-transparent popUpOpenAnimation1"
          role="dialog"
          aria-modal="true"
          title="undefined:Main Dialog"
        >
          <svg
            onClick={() => {
              setOpen(false);
            }}
            className="absolute top-1 right-1 z-10 h-6 w-6 cursor-pointer"
            height={24}
            width={24}
            aria-hidden="true"
            focusable="false"
            data-prefix="fad"
            data-icon="circle-xmark"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <g className="fa-duotone-group">
              <path
                fill="currentColor"
                d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
              />
              <path
                fill="white"
                d="M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"
              />
            </g>
          </svg>
          <div className="relative overflow-hidden w-full h-auto rounded-md md:rounded-[8px] bg-white">
            <img
              src={
                imgData?.self_host
                  ? `${BASE_DEV_URL}/${imgData?.content}`
                  : imgData?.content
              }
              alt={1}
              // sizes="(max-width: 600px) 100vw, (max-width: 800px) 50vw, 600px"
              className="  w-full h-full object-cover md:max-w-[600px]"
              loading="lazy"
              imgwidth={250}
              imgheight={100}
            />

            {!is_demo && IS_B2C && (
              <div className="p-4 space-y-3">
                <div>
                  <h2 className="text-base font-semibold text-gray-800">
                    Refer and Earn
                  </h2>
                  {/* <p className="text-xs text-gray-500">
                  Send this link to your friends and start earning
                </p> */}
                </div>

                <div className="flex items-center border-primary border-[2px] border-dashed gap-2  rounded-md p-1">
                  <textarea
                    value={affiliateLink}
                    readOnly
                    rows={2}
                    className="flex-1 bg-transparent text-sm outline-none px-2 resize-none break-words"
                  />
                  <button
                    onClick={copyAffiliateLink}
                    className={`px-3 py-1.5 rounded-lg text-sm font-medium transition bg-red-500 text-white hover:bg-red-600`}
                  >
                    Copy
                  </button>
                </div>

                {(promotions?.Whatsapp?.is_active ||
                  promotions?.Telegram?.is_active ||
                  promotions?.Instagram?.is_active) && (
                  <div className="flex items-center justify-between">
                    <p className="text-sm text-gray-600 mb-2 font-semibold">
                      Share via :{" "}
                    </p>

                    <div className="flex gap-2">
                      {promotions?.Whatsapp?.is_active && (
                        <a
                          href={`https://wa.me/?text=${encodeURIComponent(affiliateLink)}`}
                          target="_blank"
                          className="   rounded-xl text-sm"
                        >
                          <img src="/what.webp" alt="whatsapp" />
                        </a>
                      )}

                      {promotions?.Telegram?.is_active && (
                        <a
                          href={`https://t.me/share/url?url=${encodeURIComponent(affiliateLink)}`}
                          target="_blank"
                          className="  text-white  rounded-xl text-sm"
                        >
                          <img src="/telegram-share.svg" alt="telegram-share" />
                        </a>
                      )}

                      {promotions?.Instagram?.is_active && (
                        <a
                          href="https://www.instagram.com/"
                          target="_blank"
                          className="   text-white rounded-xl text-sm"
                        >
                          <img
                            src="/instagram-share.svg"
                            alt="instagram-share"
                          />
                        </a>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupImage;
